export const GAME_WIDTH = 1440;
export const GAME_HEIGHT = 810;
export const SAVE_KEY = 'rohas-closet-save';
export const SAVE_VERSION = 5; // 펫 클린 슬레이트 + 테스트 통화 99999
export const AUTOSAVE_INTERVAL_MS = 30_000;
